import { useMutation } from '@tanstack/vue-query';

import providerInstance from '@/services/provider';

export function useQuoteCreateSalesforceOpportunity() {
  const { isLoading, isError, error, isSuccess, mutate, reset } = useMutation({
    mutationKey: ['create-sales-force-opportunity'],
    mutationFn: (quoteNumber: number) =>
      providerInstance.quote.createSalesforceOpportunity(quoteNumber)
  });
  return {
    isLoading,
    isError,
    error,
    isSuccess,
    mutate,
    reset
  };
}
